import { useState } from 'react'
import { useWorks } from '@/hooks/useWorks'
import { WorksTable, type WorkFilter } from '@/components/features/works/WorksTable'

export function Works() {
  const { data: works, isLoading, error } = useWorks()
  const [filter, setFilter] = useState<WorkFilter>('all')

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-muted-foreground">Loading works...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-6">
        <h2 className="font-semibold text-destructive">Failed to load works</h2>
        <p className="mt-1 text-sm text-muted-foreground">{error.message}</p>
      </div>
    )
  }

  if (!works || works.length === 0) {
    return (
      <div className="space-y-4">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Works</h1>
          <p className="text-muted-foreground mt-2">No works found.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Works</h1>
        <p className="text-muted-foreground mt-2">
          Browse and manage work records. Click a row to view details.
        </p>
      </div>
      <WorksTable works={works} filter={filter} onFilterChange={setFilter} />
    </div>
  )
}
